import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import api from '../../conf/api';
import PersonIcon from '@mui/icons-material/Person';

function UserAutoComplete({ label = 'Select user', onChange, fetchOptions = undefined, loading = false, params = {}, user, selectUserObj = false, emptySelection = false, size = "small", variant = "outlined", sx = {}, onClose = () => { } }) {
  const [options, setOptions] = useState({ loading: false, data: [] });
  const [selectedUser, selectUser] = useState(null);

  const fetchUsers = async () => {
    if (fetchOptions !== undefined) {
      fetchOptions(setOptions)
    }
    else {
      try {
        setOptions((pre) => ({ ...pre, loading: true }));
        const res = await api.get("/users/list", { params: params });
        setOptions((pre) => ({ ...pre, data: res.data?.results }));

        if (user) {
          const _user = res.data.results.find(usr => usr.id === user || usr.username === user);
          if (_user) {
            selectUser(_user);
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        setOptions((pre) => ({ ...pre, loading: false }));
      }
    }
  };

  useEffect(() => {
    if (user !== "") {
      fetchUsers();
    }
    else {
      selectUser(null)
    }
    // eslint-disable-next-line
  }, [user]);

  useEffect(() => {
    if (selectedUser !== null) {
      const _user = selectUserObj ? selectedUser : selectedUser.id;
      onChange(_user);
      if (emptySelection) {
        setTimeout(() => {
          selectUser(null);
        }, 800);
      }
    }
    else {
      onChange(null);
    }
    // eslint-disable-next-line
  }, [selectedUser]);


  return (
    <Autocomplete
      onOpen={fetchUsers}
      onClose={onClose}
      sx={{ minWidth: 200, ...sx }}
      size={size}
      value={selectedUser}
      onChange={(e, _value) => {
        selectUser(_value);
      }}
      options={options.data}
      getOptionLabel={(option) => `${option.username} \n (${option.email})`}
      loading={options.loading || loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant={variant}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <React.Fragment>
                <PersonIcon />
                {params.InputProps.startAdornment}
              </React.Fragment>
            ),
            endAdornment: (
              <React.Fragment>
                {options.loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  )
}

export default UserAutoComplete;
